<template>
  <section class="facility-list-item pb-4">
    <div class="form-row align-items-center">

      <div class="col-11 col-md-11 row">

        <div class="col-12 col-md-5 d-flex flex-column">
          <h5>{{facility.name}}</h5>
          <div>
            <label class="is-bold">{{$t('facility.inputs.phone')}}:</label>
            &nbsp;
            <span>{{ facility.phone || 'n.d' }}</span>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <span class="is-bold">{{$t('facility.inputs.address')}}:</span>
          <br>
          <span v-if="formattedAddress">{{ formattedAddress }}</span>
          <span v-else>n.d</span>
          &nbsp;
          <span class="mr-3" v-if="hasLocation">
            <i class="fa fa-map-marker map-icon p-2 clickable" @click="isShowingMap = true"></i>
          </span>
        </div>
      </div>

      <div class="col-1 col-md-1 justify--end d-flex" v-if="hasWritePermissionsToEntity">
        <va-dropdown
          v-if="hasWritePermissionsToEntity"
          class="custom-dropdown"
          fixed>
          <span slot="anchor">
            <slot>
              <div class="pl-3 pr-2 clickable">
                <span class="fa fa-ellipsis-v" style="font-size: 1.5rem;"></span>
              </div>
            </slot>
          </span>
          <div class="contact-dropdown__content pl-3 pr-2 pt-2 pb-2">
            <div class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2" @click.prevent="updateFacility">
              <i class="fa fa-pencil"></i>&nbsp;
              <span class="pl-2">{{$t('people.actions.edit_address')}}</span>
            </div>
            <div class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2" @click.prevent="updateFacilitySchedule">
              <i class="fa fa-pencil"></i>&nbsp;
              <span class="pl-2">{{$t('people.actions.edit_schedule')}}</span>
            </div>
            <div class="contact-dropdown__item row align--center pl-3 pt-1 pb-1 mt-2 mb-2" @click.prevent="deleteFacility">
              <i class="fa fa-trash"></i>&nbsp;
              <span class="pl-2">{{$t('people.actions.delete')}}</span>
            </div>
          </div>
        </va-dropdown>
      </div>
    </div>
    <div v-if="facility.schedules" class="col-12 pt-3">
      <collapsable
        :collapsed="facilitySchedulesColapsed"
        :title_h5="$t('facilities.availability_schedule_title')"
      >
        <!--<h5>{{ $t('facilities.availability_schedule_title') }}</h5>-->
        <FacilitySchedulesTable ref="schedulesTable" :schedules="facility.schedules" :finallyId="facility.id" @update-schedules="updateFacilitySchedule"/>
        <div class="justify--space-between row">
          <div>
            <span class="is-bold">{{ $t('facilities.inputs.marketing_code') }}: </span>
            <span>{{ facility.marketing_code || "N/A" }}</span>
          </div>
          <div>
            <span class="is-bold">{{ $t('facilities.inputs.grace_period') }}: </span>
            <span>{{ facility.grace_period || "N/A" }}</span>
          </div>
          <div>
            <span class="is-bold">{{ $t('facilities.inputs.appointments_limit') }}: </span>
            <span>{{ facility.appointments_limit || "N/A" }}</span>
          </div>

        </div>
      </collapsable>
    </div>
    <ShowFacilityMap v-if="isShowingMap"
      :facility="facility"
      @cancel="isShowingMap = false"
    />

  </section>
</template>
<script>
import ShowFacilityMap from '@/components/entities/facilities/ShowFacilityMap'
import FacilitySchedulesTable from './facility-schedules/FacilitySchedulesTable.vue'
import Collapsable from "@/components/common/Collapsable.vue";

const entityInfoType = 110
const writeAccessType = 2

export default {
  props: {
    facility: {
      type: Object,
      required: true
    }
  },
  components: {
    Collapsable,
    ShowFacilityMap,
    FacilitySchedulesTable
  },
  computed: {
    hasLocation: function () {
      return this.facility && this.facility.address && this.facility.address.lat && this.facility.address.lng
    },
    formattedAddress: function () {
      let addressSections = []
      if (this.facility.address) {
        let keys = ['line1', 'line2', 'city', 'postal_code']
        keys.forEach(key => {
          if (this.facility.address[key]) {
            addressSections.push(this.facility.address[key])
          }
        })
      }
      return addressSections.join(', ')
    },
    authService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.evollauth_server) || null
    },
    hasWritePermissionsToEntity: function () {
      return this.authService && this.authService.user_permissions.some(p => (p.entity_id === null || p.entity_id === this.facility.entity.id) && p.info_type === entityInfoType && p.access_type === writeAccessType)
    }
  },
  data: function () {
    return {
      isShowingMap: false,
      facilitySchedulesColapsed: true
    }
  },
  methods: {
    updateFacility: function () {
      this.$emit('update-facility', { facility: this.facility })
    },
    updateFacilitySchedule: function ({facilitySchedule}) {
      this.$emit('update-facility-schedules', { facility: this.facility, facilitySchedule })
    },
    deleteFacility: function () {
      this.$emit('delete-facility', { facility: this.facility })
    }
  }
}
</script>
<style lang="scss">
.VuePagination {
  display: none !important;
}

.facility-list-item {
  border: solid 1px #ededed;
  background-color: #ededed;
  box-shadow: 8px 8px 8px #e0e0e0;
  border-radius: 15px;
  padding: 8px;
  margin-bottom: 10px;
}
</style>
